import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import topBar from '@/components/top-bar'
import topTitle from '@/components/top-title'
import icon from '@/components/icon'
import pageBottom from '@/components/page-bottom'
import pageBelt from '@/components/page-belt'
import audioProgress from '@/components/audio-progress'
import formModal from '@/components/form-modal'
import num from '@/components/num'
import tip from '@/components/tip'
import bannerBtn from '@/components/banner-btn'
import { loadJs } from '@/common/utils.js'
import './stylus/fonts.styl'

Vue.config.productionTip = false

Vue.prototype.$http = api

Vue.component('top-bar', topBar)
Vue.component('top-title', topTitle)
Vue.component('icon', icon)
Vue.component('page-bottom', pageBottom)
Vue.component('page-belt', pageBelt)
Vue.component('audio-progress', audioProgress)
Vue.component('form-modal', formModal)
Vue.component('num', num)
Vue.component('tip', tip)
Vue.component('banner-btn', bannerBtn)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

loadJs('https://s13.cnzz.com/z_stat.php?id=1274465175&web_id=1274465175')

window._hmt = window._hmt || []
// App.loadJs('https://hm.baidu.com/hm.js?85d04f1ea5f85c3f453b48bd35ffa953')
loadJs('https://hm.baidu.com/hm.js?24790103c591d18ee7e8a474be178de2')
// loadJs('//ikoubei.baidu.com/embed/b1d173f19dc674d179a21e2d03f09d38', { name: 'baidu-koubei-verification' })
